import { DefaultArtifactBlock } from './DefaultArtifactBlock';
const artifactBlockRegistry = {
  HTML: DefaultArtifactBlock,
  MARKDOWN: DefaultArtifactBlock,
  // TODO: temp — EMAIL renders like Markdown today. Migrate to a dedicated
  // formatter that mirrors BA's EmailDraftCardResponseSection chrome (insert
  // button, sources list, etc.) once the BZE artifact chat block carries
  // email metadata (subject, recipients, body).
  EMAIL: DefaultArtifactBlock
};
export const getArtifactBlockFormatter = artifactType => artifactType && artifactBlockRegistry[artifactType] || DefaultArtifactBlock;